import Image from 'next/image';

import Hero from '@/images/Pages/ADelps/SecaoFullWidth/secao-full-width.jpg';

import { Container } from './styles';

const HeroSection = (): JSX.Element => {
  return (
    <Container>
      <Image
        src={Hero}
        alt="Foto de funcionários da Delps nos 25 anos"
        quality={100}
        placeholder="blur"
      />
    </Container>
  );
};

export default HeroSection;
